export default __webpack_public_path__ + "static/our-services-de0d3b58f30532a852697fef6f6a9153.png";